import angular from 'angular'
import routers from './routers.js'
import creatDeclarationCtrl from './creatDeclarationCtrl.js'
import creatDeclarationDetailCtrl from './creatDeclarationDetailCtrl.js'

export default angular
    .module('declaration.addValTaxDeclaration.creatDeclaration', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('creatDeclarationCtrl', creatDeclarationCtrl)
    .controller('creatDeclarationDetailCtrl', creatDeclarationDetailCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/creatDeclaration/index.js